import { gql } from 'graphql-request'

export const COMPLETE_PROFILE_MUTATION = gql`
  mutation CompleteProfile($input: profile_insert_input!, $profileId: uuid!) {
    profile: insert_profile_one(
      object: $input
      on_conflict: {
        constraint: profile_pkey
        update_columns: [
          _given_name
          _family_name
          _phone
          country
          countryCode
          phoneCountryCode
          dob
          jobTitle
        ]
      }
    ) {
      id
      givenName
      familyName
      email
    }
    # SSO email is already verified by the IdP, so drop any leftover
    # 'unverified' role (e.g. from an earlier, never-verified direct signup).
    delete_profile_role(
      where: {
        profile_id: { _eq: $profileId }
        role: { name: { _eq: "unverified" } }
      }
    ) {
      affected_rows
    }
  }
`
